import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(()=>({
  ul:{
    justifiyContent: 'space-around',
  },
}))
